/*
 * @Author: jikeychang@gmail.com
 * @Date: 2021-03-03 17:24:43
 * @LastEditors: jikeychang@gmail.com
 * @LastEditTime: 2021-03-03 17:25:51
 * @Description: FileDescription
 */
// import qs from 'qs';
import db from './db';

const model = {
  /**
   * 数据字典
   */
  // 获取:数据字典
  getDataDictionaryList(param) {
    return db.post('/sys/dictionary/page', param);
  },
  // 查看:数据字典
  dtlDataDictionaryList(param) {
    return db.post('/sys/dictionary/list', param);
  },
  // 删除:数据字典
  delDataDictionaryList(param) {
    return db.post('/sys/dictionary/delete', param);
  },
  // 新增:数据字典
  addDataDictionaryList(param) {
    return db.post('/sys/dictionary/create', param);
  },
  // 编辑:数据字典
  editDataDictionaryList(param) {
    return db.post('/sys/dictionary/modify', param);
  },
  // 系统数据源
  getSystemSources() {
    return db.get('/sys/dictionary/getSysName', { typeCode: 'SYSTEM' });
  },
};

export default model;
